module.exports = __webpack_public_path__ + "static/media/twentyassists.4116c62c.jpg";